import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import xeroIcon from '~/assets/public/xero-icon.png';
import { BackLink, Icon, Page, Tooltip } from '~/components';
import { useApi, useIntegrations, useWorkspace } from '~/contexts';
import XeroSettingsPage from './XeroSettingsPage';
import { Redirect, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { colors } from '~/styles';

const XeroLogo = styled.img`
  width: 2.875rem;
  height: 2.875rem;
  max-width: unset;
`;

const PageTitle = styled(Page.Title)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export default function XeroSettingsArea() {
  const { xeroConnectionId } = useParams();
  const { url } = useRouteMatch();
  const { workspace } = useWorkspace();
  const { xero } = useIntegrations();
  const api = useApi();
  const [xeroConnection, setXeroConnection] = useState({ data: null, isReady: false });

  const fetchXeroConnection = useCallback(async () => {
    if (!xeroConnectionId) return;
    const { data } = await api.www.workspaces(workspace.id).xero(xeroConnectionId).getStatus();
    setXeroConnection({ data, isReady: true });
  }, [api, xeroConnectionId, workspace.id]);

  useEffect(() => {
    fetchXeroConnection();
  }, [fetchXeroConnection]);

  if (!xero) return null;
  if (!xero.some(({ id }) => id === xeroConnectionId)) {
    return <Redirect to={url.split('/xero/')[0]} />;
  }

  return (
    <>
      <Page>
        <Page.Header>
          <BackLink defaultPath={`/app/${workspace.key}/settings/integrations`} ignoreHistory />

          <Page.Info>
            <Page.Eyebrow>Settings</Page.Eyebrow>
            <PageTitle>
              {xeroConnection.isReady ? (
                <>
                  {xeroConnection.data?.name ?? 'Xero'}
                  {xeroConnection.data?.status !== 'ok' && (
                    <Tooltip message={xeroConnection.data?.message}>
                      <Icon icon="warning" color={colors.warning} />
                    </Tooltip>
                  )}
                </>
              ) : (
                'Xero'
              )}
            </PageTitle>
          </Page.Info>

          <Page.Actions>
            <XeroLogo src={xeroIcon} />
          </Page.Actions>
        </Page.Header>

        <XeroSettingsPage />
      </Page>
    </>
  );
}
